<template>
  <div>
    <InformationAboutStudentLeavingTable ref="groupInformationAboutStudentLeavingTable"></InformationAboutStudentLeavingTable>
  </div>
</template>
<style>
.dropped td {
  background-color: #F64E60;
}
</style>
<script>
import InformationAboutStudentLeavingTable from "@/views/pages/edu/schools/reports/partials/InformationAboutStudentLeavingTable.vue";
export default {
  name: "GroupInformationAboutStudentLeavingReport",
  components: {
    InformationAboutStudentLeavingTable
  },
  props:{
    groupId:String
  },
  data() {
    return {

    };
  },
  mounted() {
  },
  methods: {    
    reloadData(){
      this.$refs['groupInformationAboutStudentLeavingTable'].redrawTable(parseInt(this.groupId));
    }
  }
};
</script>
